export default __webpack_public_path__ + "static/medialinq-logo-3c0222c2dfbfb89334bedfed6b0318ed.png";